export const /** @type {?} */ NotificationTemplates = {
  defaultTemplate: {
    property: {
      display: true,
      disable: false,
      position: 'top-right', // can be: top-left, top-right, bottom-right, bottom-left
      theme: '', // name of theme
      classes: 'mat-primary' // classes for notification container
    }
  }
}
